import { useQuery } from "@tanstack/react-query";
import { tenantApi } from "@/lib/api/client";
import { WeeklyScheduleView } from "@nodus/ui";
import { Box, Card, Stack, Text, Title } from "@mantine/core";

export default function DoorbellPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["weekly-schedule"],
    queryFn: () => tenantApi.getWeeklySchedule(),
  });

  if (isLoading) return <Box p="md">Loading...</Box>;

  if (isError) {
    return (
      <Box p="md">
        <Text fz="sm" c="red">Failed to load data. Please try again later.</Text>
      </Box>
    );
  }

  const schedules = data?.data.schedules ?? [];
  const override = data?.data.opening_override ?? null;

  return (
    <Stack p="md" gap="xl">
      <Title order={1} fz="xl" fw={700}>Doorbell Hours</Title>

      <Card padding="lg" withBorder>
        <Stack gap="md">
          <Text fw={600} fz="lg">Weekly Schedule</Text>
          <WeeklyScheduleView schedules={schedules} override={override} />
        </Stack>
      </Card>
    </Stack>
  );
}
